// npm imports
import React, { Component } from "react";
import { debounce } from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../../../revvComponents";

// Components Imports
import TemplateSearchDropdown from "./TemplateSearchDropdown";

// Actions Imports
import {
  updateTemplateSearchSuggestions,
  updateTemplateSearchContent,
  updateStatusFilters,
} from "../../../../actions/DocumentTemplateActions/templateActions";
// Internal Imports
import { PATHS } from "../../../../constants";

// Destructuring

class TemplateHeaderSearch extends Component {
  state = {
    searchInput: "",
    showDropdown: false,
    pointer: -1,
  };

  delaySearch = debounce(keyword => {
    this.searchAssetContent(keyword);
  }, 400);

  toggleDropdown = show => {
    this.setState({ showDropdown: show });
  };

  handleSearchInputChange = e => {
    this.setState({
      searchInput: e.target.value,
    });
    if (e.target.value.length >= 3) {
      this.delaySearch(e.target.value);
    }
  };

  handleKeyDown = e => {
    const { pointer } = this.state;
    if (e.which === 9) {
      this.toggleDropdown(false);
    }
    if (e.key === "Enter") {
      this.props.updateStatusFilters([]);
      if (pointer === -1) {
        this._getSearchResults();
      } else {
        this.props.history.push(
          `${PATHS.DOCSTEMPLATE_PATH}/${this.props.templateSuggesstions[pointer].id}`,
        );
      }
    }

    if (e.keyCode === 38 && pointer > 0) {
      this.setState(prevState => ({
        pointer: prevState.pointer - 1,
      }));
    } else if (
      e.keyCode === 40 &&
      pointer < this.props.templateSuggesstions.length - 1
    ) {
      this.setState(prevState => ({
        pointer: prevState.pointer + 1,
      }));
    }
  };

  _getSearchResults = () => {
    const {
      updateTemplateSearchContent: updateTemplateSearch,
      type,
      toggleSearchPage,
    } = this.props;
    const { searchInput: searchTerm } = this.state;
    let isGlobal = false;
    if (type === "global") {
      isGlobal = true;
    }
    if (searchTerm.trim()) {
      if (searchTerm.length > 2) {
        updateTemplateSearch(searchTerm, isGlobal, 0)
          .then(() => {
            this.toggleDropdown(false);
            toggleSearchPage(true);
          })
          .catch(() => {});
      }
    }
  };

  searchAssetContent = searchTerm => {
    const { updateTemplateSearchSuggestions: updateSuggestion, type } =
      this.props;
    let isGlobal = false;
    if (type === "global") {
      isGlobal = true;
    }
    updateSuggestion(searchTerm, isGlobal).catch(() => {});
  };

  render() {
    const { searchInput, showDropdown, pointer } = this.state;
    const {
      type,
      toggleSearchPage,
      // showSearchPage,
      togglePreview,
    } = this.props;
    return (
      <div className="templateheader-search">
        <FontAwesomeIcon
          icon={["far", "search"]}
          className="templateheader-searchicon"
        />
        <Input
          data-test="template-search-input"
          className="templateheader-input"
          placeholder={
            type === "global"
              ? "Search templates, eg. proposal, agreement"
              : "Search templates by name"
          }
          value={searchInput}
          onFocus={() => this.toggleDropdown(true)}
          onChange={this.handleSearchInputChange}
          onKeyDown={this.handleKeyDown}
          data-id="template-search"
        />
        {/* {showSearchPage ? (
          <span
            className="templateheader-closeicon-parent"
            onKeyDown={() => {}}
            tabIndex="0"
            role="button"
            onClick={() => toggleSearchPage(false)}>
            <FontAwesomeIcon
              icon={["far", "times-circle"]}
              className="templateheader-closeicon"
            />
          </span>
        ) : null} */}
        <TemplateSearchDropdown
          showDropdown={showDropdown}
          pointer={pointer}
          toggleDropdown={this.toggleDropdown}
          searchTerm={searchInput}
          toggleSearchPage={toggleSearchPage}
          togglePreview={togglePreview}
          type={type}
          key={type}
        />
      </div>
    );
  }
}

TemplateHeaderSearch.propTypes = {
  type: PropTypes.string.isRequired,
  updateTemplateSearchSuggestions: PropTypes.func.isRequired,
  toggleSearchPage: PropTypes.func.isRequired,
  // showSearchPage: PropTypes.bool.isRequired,
  togglePreview: PropTypes.func.isRequired,
};

const mapStateToProps = ({ TemplateStore: { templateSearchSuggestions } }) => ({
  templateSuggesstions: templateSearchSuggestions,
});

const mapDispatchToProps = {
  updateTemplateSearchSuggestions,
  updateTemplateSearchContent,
  updateStatusFilters,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(TemplateHeaderSearch));
